export function isMobile() {
    return window.innerWidth < 991.99
}
